module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/consultants.ab4c9b7a15b24e0644ac7e57efaa1049.jpg";